import { Flex } from '@buffer-mono/popcorn'

import { graphql } from '~publish/graphql'
import type { FragmentOf } from '~publish/graphql'

import {
  CommentStatsBanner,
  CommentStatsBanner_Channel,
} from './CommentsStatsBanner'
import type { CommentStatsBannerChannel } from './CommentsStatsBanner'
import { TemplateSuggestion } from './TemplateSuggestion'

import type { JSX } from 'react'

export const CommentsEngagementPanel_Channel = graphql(
  `
    fragment CommentsEngagementPanel_Channel on Channel @_unmask {
      id
      ...CommentStatsBanner_Channel
    }
  `,
  [CommentStatsBanner_Channel],
)

/** @see CommentStatsBannerChannel for why this is still an intersection. */
export type CommentsEngagementPanelChannel = FragmentOf<
  typeof CommentsEngagementPanel_Channel
> &
  CommentStatsBannerChannel

type CommentsEngagementPanelProps = {
  channels: CommentsEngagementPanelChannel[]
  postId?: string
}

export const CommentsEngagementPanel = ({
  channels,
  postId,
}: CommentsEngagementPanelProps): JSX.Element | null => {
  if (channels.length === 0) return null

  const firstChannelId = channels[0]?.id

  return (
    <Flex gap="md" direction="column">
      <TemplateSuggestion preselectChannelId={firstChannelId} />
      <CommentStatsBanner channels={channels} postId={postId} />
    </Flex>
  )
}
